import { forwardRef } from 'react';

import * as flags from './assets/static';

export interface LanguageIconProps {
    language: string;
    width?: number | '100%';
    height?: number | '100%';
    alt?: string;
}

const LanguageIcon = forwardRef<HTMLImageElement, LanguageIconProps>(
    ({ language, width = '100%', height = '100%', ...props }, ref) => {
        const code = language.toUpperCase();

        const imageSource = flags[code as keyof typeof flags] || flags.NONE;

        return <img src={imageSource} alt={code} width={width} height={height} {...props} ref={ref} />;
    },
);

LanguageIcon.displayName = 'LanguageIcon';

export default LanguageIcon;
